import { jsx } from 'react/jsx-runtime';
import styles from './StatusIndicator.module.css.js';

function StatusIndicator({ isComplete = false, theme = 'primary' }) {
    return jsx("div", {
        className: [
            styles.statusIndicator,
            styles[`${theme}Color`],
            isComplete && styles.isComplete
        ].filter(Boolean).join(' ')
    });
}

export { StatusIndicator as default };
